<template>
  <RemotePaginatedList :headers="headers"
                       multi-sort
                       data-url="aafb/gym_booking/"
                       data-key="bookings"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.reference_number="{value}">
      {{ "GYM" + value.toString().padStart(10, '0')}}
    </template>
    <template v-slot:item.date="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template v-slot:item.checkin_time="{value}">
      <v-icon v-if="value">fas fa-check</v-icon>
    </template>
    <template v-slot:item.status="{value}">
      {{ $t(BOOKING_STATUS_LABEL[value]) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-btn icon color="primary"
             v-if="item.status === 1 && !item.checkin_time"
             @click="cancelBooking(item)">
        <v-icon>fas fa-trash</v-icon>
      </v-btn>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from "@vue/composition-api";
import {BOOKING_STATUS_LABEL} from "@/constants";
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'UserGymBookingList',
  components: {RemotePaginatedList},
  setup(props, {root, emit}) {
    const innerRefreshTrigger = ref(false);
    const refresh = async function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Data Table
    const headers = ref([
      {text: root.$t('gym_booking.reference_number'), value: 'reference_number'},
      {text: root.$t('gym_booking.date'), value: 'date'},
      {text: root.$t('gym_booking.checkin_time'), value: 'checkin_time'},
      {text: root.$t('gym_booking.booking_status'), value: 'status'},
      // {text: '', value: 'actions'},
    ]);

    const cancelBooking = function (item) {
      if (confirm(root.$t('gym_booking.cancel_confirm_msg'))) {
        root.$callAPI('aafb/gym_booking/cancel/', {booking_id: item.id}, () => {
          refresh();
        })
      }
    };

    return {
      innerRefreshTrigger,

      headers,

      cancelBooking,

      BOOKING_STATUS_LABEL,
    }
  },
}
</script>

<style lang="less">
.b-table-empty-row {
  color: #444;
  font-size: 2rem;
}

</style>
